/**
 * Бюро кредитных историй дела — одно или два (просьба заказчика 01.11.2026).
 *
 * Должник бывает в двух бюро, и юрист прикладывает оба отчёта. Заявление
 * тогда называет оба бюро («из кредитных историй, выданных А и Б»), перечень
 * приложений — два пункта «Кредитный отчёт (бюро)». Второе бюро хранится
 * отдельными полями: профили, сохранённые раньше, остаются как есть.
 */

import type { Legal } from '../types/legal.js';

export interface CaseCreditBureau {
  name: string;
  reportKind: string;
}

/** Выбранные бюро по порядку; пустые и повтор первого не считаются. */
export function caseCreditBureaus(legal: Legal): CaseCreditBureau[] {
  const list: CaseCreditBureau[] = [];
  const first = legal.creditBureau.name.trim();
  if (first) list.push({ name: first, reportKind: legal.creditReportKind });
  const second = legal.secondCreditBureau?.name.trim() ?? '';
  if (second && second !== first) list.push({ name: second, reportKind: legal.secondCreditReportKind ?? '' });
  return list;
}
